import { useTranslation } from "react-i18next";

import "./LanguageSwitcher.scss";
import { languages, languageLabels } from "../../constants";

export const LanguageSwitcher = ({ className = "" }) => {
  const { i18n } = useTranslation();

  const resolved =
    languages.find(
      (l) => i18n.language === l || i18n.language.startsWith(`${l}-`)
    ) ?? languages[0];

  const toggle = () => {
    const next = languages.find((l) => l !== resolved);
    if (next) i18n.changeLanguage(next);
  };

  const rootClass = ["language-switcher", "language-switcher--toggle", className]
    .filter(Boolean)
    .join(" ");

  return (
    <button
      type="button"
      className={rootClass}
      data-active-lang={resolved}
      onClick={toggle}
      role="switch"
      aria-checked={resolved === "srb"}
      aria-label={`Language: ${languageLabels[resolved] ?? resolved}. Click to switch.`}
    >
      <span className="language-switcher-track" aria-hidden>
        <span className="language-switcher-thumb" />
        <span className="language-switcher-labels">
          {languages.map((lang) => (
            <span
              key={lang}
              className={`language-switcher-label ${resolved === lang ? "is-active" : ""}`}
            >
              {languageLabels[lang] ?? lang}
            </span>
          ))}
        </span>
      </span>
    </button>
  );
};
